import { render } from "./RichTextArea.vue?vue&type=template&id=2edcf694&scoped=true"
import script from "./RichTextArea.vue?vue&type=script&lang=js"
export * from "./RichTextArea.vue?vue&type=script&lang=js"

import "./RichTextArea.vue?vue&type=style&index=0&id=2edcf694&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2edcf694"]])

export default __exports__